import { createContext, useContext } from "react";
function missingContextWarning() {
    console.warn(`${Context.displayName}: missing provider`);
}
const defaultContext = {
    home: missingContextWarning,
    application: missingContextWarning,
    applicationWithStep: missingContextWarning,
    applicationFromCalculator: missingContextWarning
};
const Context = createContext(defaultContext);
Context.displayName = "NavigationState";
export const NavigationContext = Context;
export const NavigationProvider = Context.Provider;
export const NavigationConsumer = Context.Consumer;
export function useNavigationState() {
    return useContext(Context);
}
//# sourceMappingURL=NavigationContext.js.map